import BorcluIski from "./BorcluIski";
import DosyaBorclulari from "./DosyaBorclulari";
import AvukatSorgulama from "./AvukatSorgulama";
import Adliyeler from "./Adliyeler";
import AvukatKisiselBilgileriSorgulama from "./AvukatKisiselBilgileriSorgulama";
import AvukatBakiyeSorgula from "./AvukatBakiyeSorgula";
import AvukatYetkiliKurumlar from "./AvukatYetkiliKurumlar";
import BorcluDib from "./BorcluDib";
import DosyaBorcluMernis from "./DosyaBorcluMernis";
import BorcluGib from "./BorcluGib";
import BorcluGsm from "./BorcluGsm";
import BorcluPostaCeki from "./BorcluPostaCeki";
import BorcluTakbisSorgulama from "./BorcluTakbisSorgulama";
import BorcluTasinmazHisseSorgulama from "./BorcluTasinmazHisseSorgulama";
import BorcluTasinmazTakyidatSorgulama from "./BorcluTasinmazTakyidatSorgulama";
import DosyaBorcluBagkur from "./DosyaBorcluBagkur";
import DosyaBorcluBankaBilgileri from "./DosyaBorcluBankaBilgileri";
import DosyaBorcluEgm from "./DosyaBorcluEgm";
import DosyaBorcluEgmMahrumiyet from "./DosyaBorcluEgmMahrumiyet";
import DosyaBorcluIsyeriSgk from "./DosyaBorcluIsyeriSgk";
import DosyaBorcluSSK from "./DosyaBorcluSSK";
import DosyaDetayBilgileri from "./DosyaDetayBilgileri";
import DosyaEvraklar from "./DosyaEvraklar";
import DosyaHarcMasrafHesabi from "./DosyaHarcMasrafHesabi";
import DosyaHesapBilgileri from "./DosyaHesapBilgileri";
import DosyaOdemeIslemleri from "./DosyaOdemeIslemleri";
import DosyaSafahat from "./DosyaSafahat";
import DosyaTarafBilgileri from "./DosyaTarafBilgileri";
import GetDosyaTarafBilgileri from "./GetDosyaTarafBilgileri";
import EvrakIndir from "./EvrakIndir";
import GetIbanDetails from "./GetIbanDetails";
import GetKurumMersisAdresi from "./GetKurumMersisAdresi";
import GonderilebilecekEvrakListesi from "./GonderilebilecekEvrakListesi";
import IcraPesinHarcGetir from "./IcraPesinHarcGetir";
import IcraTakipIlamDosyasiUygunMu from "./IcraTakipIlamDosyasiUygunMu";
import IcraTakipIlamDosyaTuru from "./IcraTakipIlamDosyaTuru";
import IldekiAdliyeler from "./IldekiAdliyeler";
import KisiMernisAdresiVarmi from "./KisiMernisAdresiVarmi";
import KisiSorgula from "./KisiSorgula";
import KurumSorgulama from "./KurumSorgulama";
import MahkemeBirimleri from "./MahkemeBirimleri";
import OdemeYap from "./OdemeYap";
import SgkKamu from "./SgkKamu";
import TahsilatReddiyat from "./TahsilatReddiyat";
import TahsilHarcOranlariniGetir from "./TahsilHarcOranlariniGetir";
import TamamlanmayanDosyalar from "./TamamlanmayanDosyalar";
import MtsTarafTebligatList from "./MtsTarafTebligatList";
import MtsTebligatUcreti from "./MtsTebligatUcreti";
import MtsTebligatGonder from "./MtsTebligatGonder";
import MtsTebligatList from "./MtsTebligatList";
import MtsTebligatSafahatList from "./MtsTebligatSafahatList";
import OdemeIslemiSorgulama from "./OdemeIslemiSorgulama";
import MakbuzIndir from "./MakbuzIndir";
import YargiBirimleri from "./YargiBirimleri";
import AvukatTalepList from "./AvukatTalepList";
import BankaHacziParams from "./BankaHacziParams";
import DosyaKapatmaNedenleri from "./DosyaKapatmaNedenleri";
import PortalAvukatTalepMalTuruList from "./PortalAvukatTalepMalTuruList";
import PortalAvukatTalepTebligatTuruList from "./PortalAvukatTalepTebligatTuruList";
import GetDosyaTarafListesiWithTarafRol from "./GetDosyaTarafListesiWithTarafRol";
import GetMaasHacziParams from "./GetMaasHacziParams";
import GetPortalAvukatTalepAdresTuruList from "./GetPortalAvukatTalepAdresTuruList";
import ParaBirimleri from "./ParaBirimleri";
import AracHacziParams from "./AracHacziParams";
import BorcluSgkHaciz from "./BorcluSgkHaciz";
import BorcluIcraDosyasi from "./BorcluIcraDosyasi";
import TakibiKesinlesenBorcluListesi from "./TakibiKesinlesenBorcluListesi";
import IcraTalepEvrakHazirla from "./IcraTalepEvrakHazirla";
import MtsIcraAcilisAlacakliTaraflar from "./MtsIcraAcilisAlacakliTaraflar";
import MtsIcraTakipBaslat from "./MtsIcraTakipBaslat";
import AvukatIcraTalepEvrakiGonder from "./AvukatIcraTalepEvrakiGonder";
import EvrakGonder from "./EvrakGonder";
import {DosyaBul} from "./DosyaBul";
import AvukatKayitliIbanList from "./AvukatKayitliIbanList";
import GetIbanListesi from "./GetIbanListesi";
import GetAdresList from "./GetAdresList";
import JsonHarcHesapla from "./JsonHarcHesapla";
import TevziAl from "./TevziAl";
import TakipTalebiIndir from "./TakipTalebiIndir";
import MtsTakipTalebiIndir from "./MtsTakipTalebiIndir";
import DosyaAcilisEvrakGonder from "./DosyaAcilisEvrakGonder";
import MtsHarcList from "./MtsHarcList";
import MtsTakipTalebiOlustur from "./MtsTakipTalebiOlustur";
import MtsDavaAcilis from "./MtsDavaAcilis";
import VakifbankSmsOnay from "./VakifbankSmsOnay";
import VakifbankHesapListesi from "./VakifbankHesapListesi";
import SetCookie from "./SetCookie";
import DosyaBorcluMersis from "./DosyaBorcluMersis";
import IcraTakipMahiyetleri from "./IcraTakipMahiyetleri";
import ChangePlayerStatus from "./ChangePlayerStatus";
import IldekiIdariBirimler from "./IldekiIdariBirimler";
import AdliyedekiTumMahkemeler from "./AdliyedekiTumMahkemeler";
import AvukatIcraDosyalari from "./AvukatIcraDosyalari";
import KisiSorgulaWithAdSoyad from "./KisiSorgulaWithAdSoyad";
import MtsAlacakliIletisimBilgisi from "./MtsAlacakliIletisimBilgisi";
import {TamamlanmayanDosyaBul} from "./TamamlanmayanDosyaBul";
import SskEmekli from "./SskEmekli";
import BagkurEmekli from "./BagkurEmekli";
import IllerIlceler from "@/plugins/uyap-plugin/uyap/IllerIlceler";
import SorguBakiyesi from "@/plugins/uyap-plugin/uyap/SorguBakiyesi";
import SorguBakiyeYukle from "@/plugins/uyap-plugin/uyap/SorguBakiyeYukle";
import SorguDosyaKontrol from "@/plugins/uyap-plugin/uyap/SorguDosyaKontrol";
import PttBarkodSorgula from "@/plugins/uyap-plugin/uyap/PttBarkodSorgula";
import BorcluBes from "@/plugins/uyap-plugin/uyap/BorcluBes";
import DosyaTarafKaydet from "@/plugins/uyap-plugin/uyap/DosyaTarafKaydet";
import MtsHarcListDosyaId from "@/plugins/uyap-plugin/uyap/MtsHarcListDosyaId";
import VekaletBuluBedeli from "@/plugins/uyap-plugin/uyap/VekaletPuluBedeli";
import KullaniciBilgileri from "./KullaniciBilgileri";
import MtsIcraAcilisDosyaBilgileri from "@/plugins/uyap-plugin/uyap/MtsIcraAcilisDosyaBilgileri";
import IcraTebligatTalebiAdresSorgula from "@/plugins/uyap-plugin/uyap/IcraTebligatTalebiAdresSorgula";
import KurumAutoSearch from "@/plugins/uyap-plugin/uyap/KurumAutoSearch";
import TevziSiraTipleri from "@/plugins/uyap-plugin/uyap/TevziSiraTipleri";

class UyapClient {
    // ok
    Adliyeler(): Adliyeler {
        return new Adliyeler();
    }

    // ok
    AvukatIcraDosyalari(): AvukatIcraDosyalari {
        return new AvukatIcraDosyalari();
    }

    DosyaTarafKaydet(): DosyaTarafKaydet {
        return new DosyaTarafKaydet();
    }
    // ok
    AracHacziParams(): AracHacziParams {
        return new AracHacziParams();
    }

    // ok
    DosyaBul(): DosyaBul {
        return new DosyaBul();
    }

    // ok
    TamamlanmayanDosyaBul(): TamamlanmayanDosyaBul {
        return new TamamlanmayanDosyaBul();
    }

    SetCookie(): SetCookie {
        return new SetCookie();
    }

    ChangePlayerStatus(): ChangePlayerStatus {
        return new ChangePlayerStatus();
    }

    // ok
    AvukatKisiselBilgileriSorgulama(): AvukatKisiselBilgileriSorgulama {
        return new AvukatKisiselBilgileriSorgulama();
    }

    AvukatBakiyeSorgula(): AvukatBakiyeSorgula {
        return new AvukatBakiyeSorgula();
    }

    // ok
    IllerIlceler(): IllerIlceler {
        return new IllerIlceler();
    }

    // ok
    AvukatIcraTalepEvrakiGonder(): AvukatIcraTalepEvrakiGonder {
        return new AvukatIcraTalepEvrakiGonder();
    }

    // ok
    AvukatSorgulama(): AvukatSorgulama {
        return new AvukatSorgulama();
    }

    // ok
    AvukatTalepList(): AvukatTalepList {
        return new AvukatTalepList();
    }

    // ok
    AvukatYetkiliKurumlar(): AvukatYetkiliKurumlar {
        return new AvukatYetkiliKurumlar();
    }

    // ok
    BankaHacziParams(): BankaHacziParams {
        return new BankaHacziParams();
    }

    // ok
    IcraTakipMahiyetleri(): IcraTakipMahiyetleri {
        return new IcraTakipMahiyetleri();
    }

    // ok
    BorcluDib(): BorcluDib {
        return new BorcluDib();
    }

    // ok
    JsonHarcHesapla(): JsonHarcHesapla {
        return new JsonHarcHesapla();
    }

    // ok
    TevziAl(): TevziAl {
        return new TevziAl();
    }

    // ok
    TevziSiraTipleri(): TevziSiraTipleri {
        return new TevziSiraTipleri();
    }

    // ok
    TakipTalebiIndir(dosyaId: string): TakipTalebiIndir {
        return new TakipTalebiIndir(dosyaId);
    }

    // ok
    MtsTakipTalebiIndir(): MtsTakipTalebiIndir {
        return new MtsTakipTalebiIndir();
    }

    // ok
    BorcluGib(): BorcluGib {
        return new BorcluGib();
    }

    // ok
    BorcluGsm(): BorcluGsm {
        return new BorcluGsm();
    }

    // ok
    BorcluIcraDosyasi(): BorcluIcraDosyasi {
        return new BorcluIcraDosyasi();
    }

    // ok
    BorcluIski(): BorcluIski {
        return new BorcluIski();
    }

    // ok
    BorcluPostaCeki(): BorcluPostaCeki {
        return new BorcluPostaCeki();
    }

    // ok
    BorcluSgkHaciz(): BorcluSgkHaciz {
        return new BorcluSgkHaciz();
    }

    // ok
    DosyaBorclulari(): DosyaBorclulari {
        return new DosyaBorclulari();
    }

    // ok
    DosyaBorcluBankaBilgileri(): DosyaBorcluBankaBilgileri {
        return new DosyaBorcluBankaBilgileri();
    }

    // ok
    DosyaBorcluMernis(): DosyaBorcluMernis {
        return new DosyaBorcluMernis();
    }

    // ok
    DosyaBorcluMersis(): DosyaBorcluMersis {
        return new DosyaBorcluMersis();
    }

    // ok
    BorcluTakbisSorgulama(): BorcluTakbisSorgulama {
        return new BorcluTakbisSorgulama();
    }

    // Taşınmaz hisse sorgulama için
    BorcluTasinmazHisseSorgulama(): BorcluTasinmazHisseSorgulama {
        return new BorcluTasinmazHisseSorgulama();
    }

    // Taşınmaz takyidat sorgulama için
    BorcluTasinmazTakyidatSorgulama(): BorcluTasinmazTakyidatSorgulama {
        return new BorcluTasinmazTakyidatSorgulama();
    }

    // ok
    DosyaBorcluBagkur(): DosyaBorcluBagkur {
        return new DosyaBorcluBagkur();
    }

    // ok
    DosyaBorcluEgm(): DosyaBorcluEgm {
        return new DosyaBorcluEgm();
    }

    // ok
    DosyaBorcluEgmMahrumiyet(): DosyaBorcluEgmMahrumiyet {
        return new DosyaBorcluEgmMahrumiyet();
    }

    // ok
    DosyaBorcluIsyeriSgk(): DosyaBorcluIsyeriSgk {
        return new DosyaBorcluIsyeriSgk();
    }

    // ok
    DosyaBorcluSSK(): DosyaBorcluSSK {
        return new DosyaBorcluSSK();
    }

    // ok
    BorcluBes(): BorcluBes {
        return new BorcluBes();
    }

    // ok
    DosyaDetayBilgileri(): DosyaDetayBilgileri {
        return new DosyaDetayBilgileri();
    }

    // ok
    DosyaEvraklar(): DosyaEvraklar {
        return new DosyaEvraklar();
    }

    // ok
    DosyaHarcMasrafHesabi(): DosyaHarcMasrafHesabi {
        return new DosyaHarcMasrafHesabi();
    }

    // ok
    DosyaHesapBilgileri(): DosyaHesapBilgileri {
        return new DosyaHesapBilgileri();
    }

    // ok
    OdemeIslemiSorgulama(): OdemeIslemiSorgulama {
        return new OdemeIslemiSorgulama();
    }

    // ok
    DosyaKapatmaNedenleri(): DosyaKapatmaNedenleri {
        return new DosyaKapatmaNedenleri();
    }

    // ok
    DosyaOdemeIslemleri(): DosyaOdemeIslemleri {
        return new DosyaOdemeIslemleri();
    }

    // ok
    DosyaSafahat(): DosyaSafahat {
        return new DosyaSafahat();
    }

    // gerek olmayabilir
    VakifbankHesapListesi(): VakifbankHesapListesi {
        return new VakifbankHesapListesi();
    }

    // gerek olmayabilir
    VakifbankSmsOnay(): VakifbankSmsOnay {
        return new VakifbankSmsOnay();
    }

    // ok
    AvukatKayitliIbanList(): AvukatKayitliIbanList {
        return new AvukatKayitliIbanList();
    }

    // ok
    GetIbanListesi(): GetIbanListesi {
        return new GetIbanListesi();
    }

    // ok
    SorguBakiyesi(): SorguBakiyesi {
        return new SorguBakiyesi();
    }

    // ok
    DosyaTarafBilgileri(): DosyaTarafBilgileri {
        return new DosyaTarafBilgileri();
    }

    // ok
    GetDosyaTarafBilgileri(): GetDosyaTarafBilgileri {
        return new GetDosyaTarafBilgileri();
    }

    // kullanılan yerlere bakılacak -dosya aracı -3. şahıs
    GetDosyaTarafListesiWithTarafRol(): GetDosyaTarafListesiWithTarafRol {
        return new GetDosyaTarafListesiWithTarafRol();
    }

    // har alınacak
    EvrakGonder(): EvrakGonder {
        return new EvrakGonder();
    }

    // ok
    DosyaAcilisEvrakGonder(): DosyaAcilisEvrakGonder {
        return new DosyaAcilisEvrakGonder();
    }

    // kullanılan yerler incelencek
    EvrakIndir(): EvrakIndir {
        return new EvrakIndir();
    }

    // ok
    MakbuzIndir(): MakbuzIndir {
        return new MakbuzIndir();
    }

    // ok
    GetIbanDetails(): GetIbanDetails {
        return new GetIbanDetails();
    }

    // ok
    GetAdresList(): GetAdresList {
        return new GetAdresList();
    }

    // ok
    GetKurumMersisAdresi(): GetKurumMersisAdresi {
        return new GetKurumMersisAdresi();
    }

    // ok
    GetIcraTebligatTalebiAdresSorgula(): IcraTebligatTalebiAdresSorgula{
        return new IcraTebligatTalebiAdresSorgula();
    }

    // ok
    GetMaasHacziParams(): GetMaasHacziParams {
        return new GetMaasHacziParams();
    }

    // ok
    GetPortalAvukatTalepAdresTuruList(): GetPortalAvukatTalepAdresTuruList {
        return new GetPortalAvukatTalepAdresTuruList();
    }

    // ok
    GonderilebilecekEvrakListesi(): GonderilebilecekEvrakListesi {
        return new GonderilebilecekEvrakListesi();
    }

    // ok
    IcraPesinHarcGetir(): IcraPesinHarcGetir {
        return new IcraPesinHarcGetir();
    }

    // ok
    IcraTakipIlamDosyasiUygunMu(): IcraTakipIlamDosyasiUygunMu {
        return new IcraTakipIlamDosyasiUygunMu();
    }

    // ok
    IcraTakipIlamDosyaTuru(): IcraTakipIlamDosyaTuru {
        return new IcraTakipIlamDosyaTuru();
    }

    // ok
    IldekiIdariBirimler(): IldekiIdariBirimler {
        return new IldekiIdariBirimler();
    }

    // ok
    IldekiAdliyeler(): IldekiAdliyeler {
        return new IldekiAdliyeler();
    }

    // ok
    AdliyedekiTumMahkemeler(): AdliyedekiTumMahkemeler {
        return new AdliyedekiTumMahkemeler();
    }

    // ok
    IcraTalepEvrakHazirla(): IcraTalepEvrakHazirla {
        return new IcraTalepEvrakHazirla();
    }

    // ok
    KisiMernisAdresiVarmi(): KisiMernisAdresiVarmi {
        return new KisiMernisAdresiVarmi();
    }

    // ok
    KisiSorgula(): KisiSorgula {
        return new KisiSorgula();
    }

    // ok
    PttBarkodSorgula(): PttBarkodSorgula {
        return new PttBarkodSorgula();
    }

    // ok
    KisiSorgulaWithAdSoyad(): KisiSorgulaWithAdSoyad {
        return new KisiSorgulaWithAdSoyad();
    }

    // ok TODO: bunu mts hazılada kullan
    MtsAlacakliIletisimBilgisi(): MtsAlacakliIletisimBilgisi {
        return new MtsAlacakliIletisimBilgisi();
    }

    // ok
    KurumSorgulama(): KurumSorgulama {
        return new KurumSorgulama();
    }

    // ok
    KurumAutoSearch(): KurumAutoSearch {
        return new KurumAutoSearch();
    }

    // ok
    MahkemeBirimleri(): MahkemeBirimleri {
        return new MahkemeBirimleri();
    }

    // ok
    MtsTarafTebligatList(): MtsTarafTebligatList {
        return new MtsTarafTebligatList();
    }

    // ok
    MtsTebligatList(): MtsTebligatList {
        return new MtsTebligatList();
    }

    // ok
    MtsTebligatSafahatList(): MtsTebligatSafahatList {
        return new MtsTebligatSafahatList();
    }

    // ok
    MtsIcraAcilisAlacakliTaraflar(): MtsIcraAcilisAlacakliTaraflar {
        return new MtsIcraAcilisAlacakliTaraflar();
    }

    // ok
    MtsIcraTakipBaslat(): MtsIcraTakipBaslat {
        return new MtsIcraTakipBaslat();
    }

    // ok
    MtsHarcList(): MtsHarcList {
        return new MtsHarcList();
    }

    //ok
    MtsHarcListDosyaId(): MtsHarcListDosyaId {
        return new MtsHarcListDosyaId();
    }

    //ok
    VekaletPuluBedeli(): VekaletBuluBedeli {
        return new VekaletBuluBedeli();
    }

    // ok
    MtsTakipTalebiOlustur(): MtsTakipTalebiOlustur {
        return new MtsTakipTalebiOlustur();
    }

    // ok
    MtsDavaAcilis(): MtsDavaAcilis {
        return new MtsDavaAcilis();
    }

    // ok
    MtsIcraAcilisDosyaBilgileri(): MtsIcraAcilisDosyaBilgileri {
        return new MtsIcraAcilisDosyaBilgileri();
    }

    // ok
    OdemeYap(): OdemeYap {
        return new OdemeYap();
    }

    // ok
    ParaBirimleri(): ParaBirimleri {
        return new ParaBirimleri();
    }

    // ok
    PortalAvukatTalepMalTuruList(): PortalAvukatTalepMalTuruList {
        return new PortalAvukatTalepMalTuruList();
    }

    // ok
    PortalAvukatTalepTebligatTuruList(): PortalAvukatTalepTebligatTuruList {
        return new PortalAvukatTalepTebligatTuruList();
    }

    // ok
    SgkKamu(): SgkKamu {
        return new SgkKamu();
    }

    // ok
    TahsilatReddiyat(): TahsilatReddiyat {
        return new TahsilatReddiyat();
    }

    // ok
    TahsilHarcOranlariniGetir(): TahsilHarcOranlariniGetir {
        return new TahsilHarcOranlariniGetir();
    }

    TakibiKesinlesenBorcluListesi(): TakibiKesinlesenBorcluListesi {
        return new TakibiKesinlesenBorcluListesi();
    }

    // ok
    TamamlanmayanDosyalar(): TamamlanmayanDosyalar {
        return new TamamlanmayanDosyalar();
    }

    // ok
    MtsTebligatUcreti(): MtsTebligatUcreti {
        return new MtsTebligatUcreti();
    }

    // ok
    MtsTebligatGonder(): MtsTebligatGonder {
        return new MtsTebligatGonder();
    }

    // ok
    YargiBirimleri(): YargiBirimleri {
        return new YargiBirimleri();
    }

    SskEmekli(): SskEmekli {
        return new SskEmekli();
    }

    BagkurEmekli(): BagkurEmekli {
        return new BagkurEmekli();
    }

    SorguBakiyeYukle(): SorguBakiyeYukle {
        return new SorguBakiyeYukle();
    }

    SorguDosyaKontrol(): SorguDosyaKontrol {
        return new SorguDosyaKontrol();
    }

    KullaniciBilgileri(): KullaniciBilgileri {
        return new KullaniciBilgileri();
    }
}

export default UyapClient;
